import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "flex items-center justify-center p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10",
    style: { "background-color": "#f2f0f0", "flex": "1" }
};
const _hoisted_2 = { class: "bg-white rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-3xl shadow-lg sm:shadow-xl md:shadow-2xl p-0 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl w-full mx-auto overflow-hidden" };
const _hoisted_3 = { class: "relative" };
const _hoisted_4 = {
    class: "rounded-t-lg sm:rounded-t-xl md:rounded-t-2xl lg:rounded-t-3xl px-4 sm:px-6 md:px-8 pt-10 sm:pt-12 md:pt-16 pb-6 sm:pb-8 text-center relative overflow-hidden",
    style: { "background": "radial-gradient(\n              56.52% 80% at 10% 0%,\n              #ffcea8 0%,\n              #fff18b 40%,\n              #ffffff 100%\n            )" }
};
const _hoisted_5 = { class: "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 sm:mb-3" };
const _hoisted_6 = { class: "text-sm sm:text-base md:text-lg text-gray-700" };
const _hoisted_7 = { class: "px-4 sm:px-6 md:px-8 py-6 sm:py-8" };
const _hoisted_8 = { class: "text-center mb-6 sm:mb-8" };
const _hoisted_9 = { class: "bg-linear-to-r from-purple-100 to-pink-100 rounded-lg sm:rounded-xl p-4 sm:p-6 mb-4 sm:mb-6" };
const _hoisted_10 = { class: "text-gray-800 text-sm sm:text-base md:text-lg leading-relaxed mb-3 sm:mb-4 font-medium" };
const _hoisted_11 = { class: "text-gray-600 text-xs sm:text-sm md:text-base" };
const _hoisted_12 = { class: "flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-6 sm:mb-8" };
const _hoisted_13 = { class: "text-center pt-4 sm:pt-6 border-t border-gray-100" };
const _hoisted_14 = { class: "text-gray-500 text-xs sm:text-sm flex items-center justify-center gap-1 sm:gap-2 px-2" };
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OnboardingSuccess',
    setup(__props) {
        const router = useRouter();
        const { t } = useI18n();
        // Navigation handlers
        const goToHome = () => {
            router.push("/dashboard");
        };
        const contactSupport = () => {
            // You can customize this based on your support system
            // For now, it opens the default email client
            window.location.href = "mailto:support@opay.com?subject=Support Request";
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"relative mb-4 sm:mb-6\" data-v-9dc3d55e><div class=\"w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-white rounded-full flex items-center justify-center mx-auto shadow-lg transform hover:scale-110 transition-transform duration-300\" data-v-9dc3d55e><svg class=\"w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-green-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-9dc3d55e><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M5 13l4 4L19 7\" data-v-9dc3d55e></path></svg></div><div class=\"absolute inset-0 flex items-center justify-center\" data-v-9dc3d55e><div class=\"w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 border-2 sm:border-4 border-amber-300 border-opacity-40 rounded-full animate-ping\" data-v-9dc3d55e></div><div class=\"absolute w-28 h-28 sm:w-32 sm:h-32 md:w-40 md:h-40 border-2 border-yellow-400 border-opacity-30 rounded-full animate-pulse\" data-v-9dc3d55e></div></div></div>", 1)),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(t)("onboardingSuccess.title")), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("onboardingSuccess.subtitle")), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("onboardingSuccess.message")), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("onboardingSuccess.nextSteps")), 1 /* TEXT */)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                                "data-testid": "go-to-dashboard-button",
                                class: "group relative bg-linear-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-lg sm:rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl flex items-center justify-center gap-2 sm:gap-3 text-sm sm:text-base",
                                onClick: goToHome
                            }, [
                                _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                    class: "w-4 h-4 sm:w-5 sm:h-5 transition-transform group-hover:scale-110",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                    })
                                ], -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("onboardingSuccess.goToHome")), 1 /* TEXT */)
                            ]),
                            _createElementVNode("button", {
                                "data-testid": "contact-support-button",
                                class: "group relative bg-white border-2 border-gray-200 hover:border-purple-300 text-gray-700 hover:text-purple-600 font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-lg sm:rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg flex items-center justify-center gap-2 sm:gap-3 text-sm sm:text-base",
                                onClick: contactSupport
                            }, [
                                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                    class: "w-4 h-4 sm:w-5 sm:h-5 transition-transform group-hover:scale-110",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                    })
                                ], -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("onboardingSuccess.contactSupport")), 1 /* TEXT */)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("p", _hoisted_14, [
                                _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                    class: "w-3 h-3 sm:w-4 sm:h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                                    })
                                ], -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("onboardingSuccess.footer")), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
